// extracted by mini-css-extract-plugin
module.exports = {"share-scroll":"share-scroll-010e5f76","share-scroll__item":"share-scroll__item-92122f7e"};